<template>
  <div
    style="
      height: 100%;
      background: #fff;
      position: relative;
      background: #eff2f5;
    "
  >
    <a-spin class="spin" tip="加载中" size="large" :spinning="loading" />
    <div class="policySearch">
      <a-tabs v-model="activeName">
        <a-tab-pane tab="政策查询" key="policySearch"></a-tab-pane>
      </a-tabs>

      <div class="cascader_filter_wrapper">
        <div class="label">政策区域：</div>
        <div class="filter_list">
          <a-cascader
            :options="policyAreaOptions"
            :default-value="[defaultAreaId]"
            :load-data="
              (selectedOptions) => getPolicyAreaOptions(selectedOptions)
            "
            :fieldNames="{
              label: 'name',
              value: 'id',
              children: 'children',
            }"
            placeholder="请选择政策区域"
            change-on-select
            @change="onChange"
          />
        </div>
      </div>
      <!-- <searchItem
        label="政策区域："
        defaultOpen
        :defaultValue="defaultAreaId"
        :options="policyArea"
        @click="
          (option) => {
            clickOption('province', option.id);
          }
        "
      /> -->
      <!-- <searchItem
        label="政策类型："
        :disable-all="!isYf"
        :active-id="isYf ? -1 : 2"
        :options="projectCat"
        @click="
          (option) => {
            clickOption('policyType', option.id);
          }
        "
      /> -->
      <!-- <searchItem
        label="政策主题："
        :options="themeTypes"
        @click="
          (option) => {
            clickOption('tagsId', option.id);
          }
        "
      /> -->
      <searchItem
        label="产业类别："
        :options="industryCat"
        @click="
          (option) => {
            clickOption('industryId', option.name);
          }
        "
      />
      <searchItem
        label="受理部门："
        :options="acceptDept"
        @click="
          (option) => {
            clickOption('department', option.id);
          }
        "
      />

      <div class="filter_item">
        <span style="line-height: 31px; padding: 0">关键词：</span>
        <input
          type="text"
          class="search"
          v-model="queryParams.keyword"
          @keyup.enter="query"
          placeholder="请输入政策关键词，如高新技术企业"
        />
        <svg-icon
          icon-class="search1"
          class="search_icon"
          @click.native="query"
        ></svg-icon>
      </div>
    </div>
    <div class="line"></div>
    <div class="con_table">
      <div class="records">
        <p>
          共为您检索到 <span>{{ total }}</span
          >条记录
        </p>
      </div>
      <template>
        <a-table
          :columns="columns"
          :data-source="tableData"
          rowKey="id"
          :customRow="
            (record) => {
              return {
                on: {
                  click: (event) => {
                    onClickRow(record);
                  },
                },
              };
            }
          "
          :pagination="{
            pageSize: queryParams.pageSize,
            current: queryParams.pageNum,
            total: total,
            showQuickJumper: true, //显示跳转页数
            showSizeChanger: true, // 显示可改变每页数量
            pageSizeOptions: ['10', '20'], // 每页数量选项
            showTotal: (total) => `共 ${total} 条`, //显示总数
          }"
          @change="showSizeChange"
        >
          <template v-slot:titleRow="data">
            <span v-html="data"></span>
          </template>

          <template v-slot:content="data">
            <a-tooltip placement="topLeft">
              <template #title>
                <span> {{ data.trim() }}</span>
              </template>
              {{ data.trim() }}
            </a-tooltip>
          </template>
        </a-table>
      </template>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "标题",
    dataIndex: "title",
    key: "title",
    width: 300,
    scopedSlots: { customRender: "titleRow" },
  },
  {
    title: "内容",
    dataIndex: "content",
    key: "content",
    scopedSlots: { customRender: "content" },
    width: 300,
    ellipsis: true,
  },
  {
    title: "部门",
    dataIndex: "departmentName",
    key: "departmentName",
    width: 200,
  },
  {
    title: "产业类别",
    dataIndex: "industryName",
    key: "industryName",
    width: 200,
  },
  {
    title: "发布时间",
    dataIndex: "time",
    key: "time",
    width: 120,
  },
];
import {
  youcewangPolicyListApi,
  youcewangPolicyOptionsApi,
  youcewangPolicyInfoApi,
} from "@/api/policySearch";
import searchItem from "./components/searchItem.vue";

export default {
  name: "policySearch",
  data() {
    return {
      tableData: [],
      columns,
      loading: false,
      total: 0,
      // queryParams: {
      //   pageNum: 1,
      //   pageSize: 10,
      //   sortType: 0,
      //   searchType: 0,
      //   province: -1,
      //   department: -1,
      //   industryId: -1,
      //   tagsId: -1, // 主题
      //   policyType: 2, // 兼容不要【全部】筛选项
      //   keyword: undefined,
      // },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        sortType: "",
        searchType: "",
        province: "",
        department: "",
        industryId: "",
        tagsId: "", // 主题
        policyType: "", // 兼容不要【全部】筛选项
        keyword: "",
      },
      activeName: "policySearch",
      //政策区域
      policyArea: [],
      PolicyAreaClass: {
        showMore: false,
      },
      //项目类别
      projectCat: [],
      projectCatClass: {
        showMore: false,
      },
      //产业类别
      industryCat: [],
      industryCatClass: {
        showMore: false,
      },
      //受理部门
      acceptDept: [],
      acceptDeptClass: {
        showMore: false,
      },
      PolicyThemeClass: {
        showMore: false,
      },
      themeTypes: [],
      defaultAreaId: "",
      isYf: false,
      policyAreaOptions: [
        {
          id: "",
          name: "全部",
          leaf: true,
        },
      ],
    };
  },
  created() {
    let url;
    if (parent !== window) {
      try {
        url = parent.location.href;
      } catch (e) {
        url = document.referrer;
      }
    }
    if (url && url.startsWith("https://yf")) {
      this.isYf = true;
      this.queryParams.policyType = "";
    }
    // for (let index = 2; index < 6; index++) {
    //   if (index !== 2) {
    //     this.fetchPolicyOption(index);
    //   }
    // }
    this.fetchPolicyOption(3);
    this.fetchPolicyOption(5);
    this.getPolicyAreaOptions();
  },
  methods: {
    async getPolicyAreaOptions(options) {
      let targetOption = options && options[options.length - 1];
      targetOption && (targetOption.loading = true);
      let res = await youcewangPolicyOptionsApi({
        type: 2,
        id: targetOption ? targetOption.id : undefined,
      });
      let rows = res.data.rows || [];
      if (!options) {
        // const arr = rows.map(item => {
        //   if (/00$/.test(item.id)) {
        //     item.isLeaf = false;
        //   }
        //   return item;
        // })
        this.policyAreaOptions.push(...rows);
        let area = sessionStorage.getItem("area")
          ? decodeURIComponent(sessionStorage.getItem("area"))
          : "";
        if (area) {
          rows = rows.filter((item) => item.name === area);
          this.defaultAreaId = rows.length ? rows[0].id : null;
          this.queryParams.province = "";
          // this.queryParams.province = this.defaultAreaId;
        }
        this.query();
      } else {
        // targetOption.children = rows.map(item => {
        //   if (/00$/.test(item.id)) {
        //     item.isLeaf = false;
        //   }
        //   return item;
        // });
        targetOption.children = rows;
      }
      this.policyAreaOptions = [...this.policyAreaOptions];
      targetOption && (targetOption.loading = false);
    },
    onChange(option) {
      if (option) {
        const length = option.length;
        let province = "",
          city = "",
          downtown = "";
        if (length >= 3) {
          downtown = option[2];
        }
        if (length >= 2) {
          city = option[1];
        }
        if (length >= 1) {
          province = option[0];
        }
        this.queryParams.province = province;
        this.queryParams.city = city;
        this.queryParams.downtown = downtown;
        this.queryParams.pageNum = 1;
        this.fetchPolicyList();
      }
    },
    onClickRow(row) {
      // row.url && window.open(row.url);
      youcewangPolicyInfoApi({ policyInfoId: row.id }).then((res) => {
        if (res.code === 0) {
          res.data.url && window.open(res.data.url);
        }
      });
    },
    query() {
      this.queryParams.pageNum = 1;
      this.fetchPolicyList();
    },
    showSizeChange({ current, pageSize }) {
      this.queryParams.pageSize = pageSize;
      this.queryParams.pageNum = current;
      this.fetchPolicyList();
    },
    clickOption(field, id) {
      this.queryParams.pageNum = 1;
      this.queryParams[field] = id;
      if (!this.queryParams.industryId) {
        this.queryParams.industryId = "";
      }
      this.fetchPolicyList();
    },
    async fetchPolicyList() {
      this.loading = true;
      try {
        const res = await youcewangPolicyListApi({ ...this.queryParams });
        this.loading = false;
        this.total = res.data.total;
        this.tableData = res.data.rows || [];
      } catch (error) {
        this.loading = false;
      }
    },
    async fetchPolicyOption(type) {
      const res = await youcewangPolicyOptionsApi({ type });
      const rows = res.data.rows || [];
      if (type === 1) {
        this.themeTypes = rows;
      } else if (type === 2) {
        this.policyArea = rows;
        const area = sessionStorage.getItem("area")
          ? decodeURIComponent(sessionStorage.getItem("area"))
          : "";
        if (area) {
          const arr = rows.filter((item) => item.name === area);
          this.defaultAreaId = arr.length ? arr[0].id : null;
          this.queryParams.province = this.defaultAreaId;
        }
        this.query();
      } else if (type === 3) {
        this.industryCat = rows;
      } else if (type === 4) {
        this.projectCat = rows;
      } else {
        this.acceptDept = rows;
      }
    },
  },
  components: {
    searchItem,
  },
};
</script>
<style lang="less" scoped>
::v-deep .ant-select-dropdown-menu-item-selected {
  background-color: #e6f7ff;
}
.spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.policySearch {
  border-radius: 10px;
  background-color: #fff;
  padding: 20px;

  ::v-deep .ant-tabs-tab-active {
    font-weight: 500;
    color: #333;
    font-size: 16px;
    padding: 12px 0;
  }

  ::v-deep .ant-tabs-tab {
    padding-top: 0;
  }

  ::v-deep .ant-tabs-ink-bar {
    width: 64px;
  }

  // .showMore {
  //   white-space: unset !important;
  //   overflow: visible !important;
  // }

  .cascader_filter_wrapper {
    display: flex;
    margin-bottom: 16px;

    .label {
      display: flex;
      align-items: center;
    }

    .filter_list {
      padding-left: 10px;

      .ant-cascader-picker {
        width: 400px;
      }
    }
  }

  .filter_item {
    display: flex;
    margin-bottom: 5px;
    //align-items: center;

    //padding-right: 64px;
    .item_box {
      flex: 1;
      //white-space: nowrap;
      overflow: hidden;
      height: 40px;
      transition: all 2s;

      span {
        display: inline-block;
      }
    }

    .showMore {
      height: auto;
      // white-space: unset !important;
      // overflow: visible !important;
    }

    ::v-deep .ant-btn {
      padding: 0;
    }

    ::v-deep .ant-btn {
      span {
        color: #0072f7;
      }
    }

    .search {
      width: 300px;
      height: 32px;
      padding-left: 10px;
      padding-right: 28px;
      margin-left: 24px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #e0e0e0;
      font-size: 14px;
      font-weight: 400;
      outline: none;
    }

    .search::-webkit-input-placeholder {
      color: #dddddd;
    }

    .search::-ms-input-placeholder {
      color: #dddddd;
    }

    .search::-moz-placeholder {
      color: #dddddd;
    }

    .search_icon {
      width: 14px;
      height: 14px;
      margin-top: 9px;
      margin-left: -28px;
      color: #0072f7;
      cursor: pointer;
    }

    span {
      // display: inline-block;
      font-size: 14px;
      font-weight: 400;
      padding: 0px 10px;
      max-height: 31px;
    }

    .option_item {
      height: 24px;
      margin-right: 10px;
      margin-bottom: 15px;
      padding: 0px 10px;
      // padding-bottom: 15px;
      cursor: pointer;
      display: block;
      //float: left;
    }

    .more {
      float: right;
      font-size: 14px;
      font-weight: 400;
      color: #999;
      cursor: pointer;
    }

    .top::after {
      transform: rotate(-135deg) !important;
      vertical-align: -1px !important;
    }

    .more::after {
      content: "";
      display: inline-block;
      width: 7px;
      height: 7px;
      margin-left: 5px;
      transform: rotate(45deg);
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
      vertical-align: 2px;
    }

    .active {
      height: 24px;
      line-height: 24px;
      background: #0072f7;
      border-radius: 4px;
      color: #fff;
    }
  }
}

.line {
  height: 10px;
  background: #eff2f5;
}

.con_table {
  border-radius: 10px;
  padding: 20px;
  padding-bottom: 0;
  background: #fff;

  ::v-deep .ant-table-thead {
    th {
      padding: 9px 16px !important;
    }
  }
  ::v-deep .ant-table-tbody {
    td {
      padding: 9px 16px !important;
      div.title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .records {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    p {
      font-size: 14px;
      font-weight: 400;
      color: #666;

      span {
        color: #ff4e00;
      }
    }
  }
}

::v-deep .ant-cascader-input {
  border: none;
}
</style>
